import { createContext, useContext } from 'react';

export const NavigationContext =
  createContext<React.RefObject<HTMLElement> | null>(null);

export const useNavigationRef = () => {
  const ref = useContext(NavigationContext);

  if (ref == null) {
    throw new Error(
      `useNavigationRef must be used inside <NavigationContext.Provider />`,
    );
  }

  return ref;
};
